import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import EasyEstimatorGrid from '../../../features/cfi/estimate-grid/components/EasyEstimatorGrid';

export default function EstimatesPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Easy Estimator')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<EasyEstimatorGrid />
			</div>
		</React.Fragment>
	)
} 
